import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const ToggleWishlistDefaultProps = {
  ...BaseDefaultProps,
  id: null,
  isFavorite: null,
  showLabel: false,
  sku: null,
};

export const ToggleWishlistPropTypes = {
  ...BasePropTypes,
  id: PropTypes.string,
  isFavorite: PropTypes.bool,
  showLabel: PropTypes.bool,
  sku: PropTypes.string,
};
